/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListResellers200ResponseInnerApiAccount } from './ListResellers200ResponseInnerApiAccount';
import {
    ListResellers200ResponseInnerApiAccountFromJSON,
    ListResellers200ResponseInnerApiAccountFromJSONTyped,
    ListResellers200ResponseInnerApiAccountToJSON,
    ListResellers200ResponseInnerApiAccountToJSONTyped,
} from './ListResellers200ResponseInnerApiAccount';

/**
 * 
 * @export
 * @interface ListResellers200ResponseInner
 */
export interface ListResellers200ResponseInner {
    /**
     * 
     */
    uuid: string;
    /**
     * 
     */
    name: string;
    /**
     * Invoices are sent to the reseller instead of its serviceproviders.
     */
    invoiced: boolean;
    /**
     * New serviceproviders created by this reseller inherit the new pricing model.
     */
    spNewPricing: boolean;
    /**
     * Number of (not deleted) serviceproviders assigned to this reseller.
     */
    serviceproviderCount: number;
    /**
     * 
     */
    apiAccount?: ListResellers200ResponseInnerApiAccount | null;
}

/**
 * Check if a given object implements the ListResellers200ResponseInner interface.
 */
export function instanceOfListResellers200ResponseInner(value: object): value is ListResellers200ResponseInner {
    if (!('uuid' in value) || value['uuid'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('invoiced' in value) || value['invoiced'] === undefined) return false;
    if (!('spNewPricing' in value) || value['spNewPricing'] === undefined) return false;
    if (!('serviceproviderCount' in value) || value['serviceproviderCount'] === undefined) return false;
    return true;
}

export function ListResellers200ResponseInnerFromJSON(json: any): ListResellers200ResponseInner {
    return ListResellers200ResponseInnerFromJSONTyped(json, false);
}

export function ListResellers200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListResellers200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'],
        'name': json['name'],
        'invoiced': json['invoiced'],
        'spNewPricing': json['spNewPricing'],
        'serviceproviderCount': json['serviceproviderCount'],
        'apiAccount': json['apiAccount'] === undefined ? undefined : json['apiAccount'] === null ? null : ListResellers200ResponseInnerApiAccountFromJSON(json['apiAccount']),
    };
}

export function ListResellers200ResponseInnerToJSON(json: any): ListResellers200ResponseInner {
    return ListResellers200ResponseInnerToJSONTyped(json, false);
}

export function ListResellers200ResponseInnerToJSONTyped(value?: ListResellers200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'name': value['name'],
        'invoiced': value['invoiced'],
        'spNewPricing': value['spNewPricing'],
        'serviceproviderCount': value['serviceproviderCount'],
        'apiAccount': ListResellers200ResponseInnerApiAccountToJSON(value['apiAccount']),
    };
}

